import React, { createContext, useContext, useState } from "react";

// Create Context
export const WishlistContext = createContext();

// Custom hook for easy access
export const useWishlist = () => useContext(WishlistContext);

// Wishlist Provider Component
export const WishlistProvider = ({ children }) => {
    const [wishlistItems, setWishlistItems] = useState([]);

    // Helper function to check for the exact item match
    const isSameItem = (item1, item2) => (
        item1.id === item2.id &&
        item1.category === item2.category &&
        (item1.subcategory === item2.subcategory)
    );

    /**
     * Toggles a product's presence in the wishlist.
     */
    const toggleWishlist = (product) => {
        setWishlistItems(prev => {
            // Check existence using the robust helper function
            const exists = prev.find(item => isSameItem(item, product));

            if (exists) {
                // If it exists, remove it (filter out the matching item based on all keys)
                return prev.filter(item => !isSameItem(item, product));
            } else {
                // If it doesn't exist, add it. 
                // Create a clean, minimal object to store essential data.
                const itemToStore = {
                    id: product.id,
                    name: product.name,
                    description : product.description,  
                    category: product.category,
                    image: product.image,
                    price: product.price,
                    subcategory: product.subcategory || null
                };

                return [...prev, itemToStore]; // add the new item
            }
        });
    };

    // 🎯 CORRECTION: Updated removeFromWishlist to accept the full product object 
    // and use the robust identification logic.
    const removeFromWishlist = (productToRemove) => {
        setWishlistItems((prevItems) => 
            // Filter out the item that matches ALL identifiers
            prevItems.filter((item) => !isSameItem(item, productToRemove))
        );
    };

    // Clear wishlist completely
    const clearWishlist = () => {
        setWishlistItems([]);
    };

    return (
        <WishlistContext.Provider
            value={{
                wishlistItems,
                toggleWishlist,
                // The updated function now ensures correct removal 
                removeFromWishlist, 
                clearWishlist
            }}
        >
            {children}
        </WishlistContext.Provider>
    );
};